import { EventToCanvas } from "./EventToCanvas";
import { prepHandleEvent } from "./prepHandleEvent";

export function handleDoubleClick(canvas) {
  return function (event) {
    var rect = canvas.getBoundingClientRect();
    var p = EventToCanvas(event, rect.left, rect.top);

    var myApp = prepHandleEvent(this, false, null, null);
    if (myApp == null) return;

    myApp.HandleDoubleClick(p.x, p.y);
  };
}
